import { picturePLaceholder } from "assets/icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { GrTextAlignLeft } from "react-icons/gr";
import { MdOutlineCheckBoxOutlineBlank } from "react-icons/md";
import { getValueOrFallback } from "utils/commonHelper";

const TextQuestion = ({ data, index, showAnswer, prevCount }) => {
  const { t } = useTranslation();
  return (
    <div className="survey_card">
      {showAnswer && (
        <h5 className="field_type">
          <span className="type_icon text">
            {prevCount + data?.questionNumber} <GrTextAlignLeft />
          </span>{" "}
          {t(`CUSTOMIZATION_QUESTION.textChoice`)}
        </h5>
      )}

      <label className="label">
        <b>{!showAnswer && prevCount + data?.questionNumber}</b>
        {getValueOrFallback(data?.question)}
      </label>
      {data?.questionImage && (
        <div className="question_image">
          <img
            src={data?.questionImage || picturePLaceholder}
            alt="question file"
          />
        </div>
      )}
      {data?.questionResponse && (
        <p>{getValueOrFallback(data?.questionResponse, "")}</p>
      )}

      {!showAnswer && (
        <ul className={`multiple_choice`}>
          <li className={`has_checkbox active`}>
            <span>{t(`CUSTOMIZATION_QUESTION.ans`)}:</span>
            <span> </span>
          </li>
        </ul>
      )}
    </div>
  );
};

export default TextQuestion;
